import React from 'react'

import NumberFormat from 'react-number-format'

// the app is crashing without this wrapper
// https://mui.com/material-ui/guides/migration-v4/#textfield
// https://github.com/s-yadav/react-number-format/issues/589

const NumberFormatTextField = React.forwardRef((props, ref) => {
  return <NumberFormat getInputRef={ref} {...props} />
})

export default NumberFormatTextField as unknown as typeof NumberFormat
